import { Component, OnInit, TemplateRef, } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Router, NavigationStart } from '@angular/router';
import { filter, first } from 'rxjs';
import { SettlementsService } from '../share/services/settlements/settlements.service';
import { PaymentAccountsService } from '../share/services/payment-account/payment-accounts.service';
import { BalanceAccountService } from '../share/services/balance-account/balance-account.service';
import { CommonServiceService } from '../share/services/common-service/common-service.service';
import { DayBookService } from '../share/services/day-book/day-book.service';
import { RangeDatePickerComponent } from 'src/app/share/range-date-picker/range-date-picker.component';
import { faExchangeAlt, faInfoCircle, faTimes, faChevronDown, faCalendar, faSpinner, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import { CompanyServiceService } from '../share/services/company-service/company-service.service';

@Component({
  selector: 'app-settlements',
  standalone: false,
  templateUrl: './settlements.component.html',
  styleUrl: './settlements.component.scss',
})
export class SettlementsComponent implements OnInit {
  faExchangeAlt = faExchangeAlt;
  faInfoCircle = faInfoCircle;
  faTimes = faTimes;
  faChevronDown = faChevronDown;
  faCalendar = faCalendar;
  faSpinner = faSpinner;
  faCalendarDays = faCalendarDays;

  cardValues = {
    historyCount: 0,
    upcomingCount: 0,
    nextSheduleDate: '',
    settledAmount: 0,
    settledCount: 0,
  }

  activeTab: 'upcoming' | 'history' = 'upcoming';
  upcomingList: any[] = [];
  historyList: any[] = [];
  historyEndOfResult: boolean = false;
  selectedMonth: string = '';

  loader: boolean = false;
  errorMessage: string = '';
  modalLoader: boolean = false;
  modalErrorMessage: string = '';
  toasterMessage: string = '';

  customSearchFn = () => true;
  manualPaymentAccounts: any[] = [];
  manualPaymentAccountsObj = { page: 0, searchTerm: '', loader: false, endofResult: false };
  paymentAccounts: any[] = [];
  paymentAccountsObj = { page: 0, searchTerm: '', loader: false, endofResult: false };
  balanceAccounts: any[] = [];
  branches: any[] = [];
  settlementTypes = [
    { label: 'All settlements', value: '' },
    { label: 'Auto', value: 'Auto' },
    { label: 'Immediate', value: 'Immediate' },
    { label: 'Manual', value: 'Manual' }
  ];

  filters = {
    accountId: null,
    company: null,
    selectedType: '',
    page: 0,
    created_datefrom: '',
    created_dateupto: ''
  };

  manualSettlementForm!: FormGroup;
  maxDate!: NgbDateStruct;
  selectedNgbDate!: NgbDateStruct;

  private modalRef: any;

  constructor(
    private readonly settlementsService: SettlementsService,
    private readonly paymentAccountsService: PaymentAccountsService,
    private readonly balanceAccountService: BalanceAccountService,
    private readonly modalService: NgbModal,
    private readonly fb: FormBuilder,
    private readonly cmns: CommonServiceService,
    private readonly companyService: CompanyServiceService,
    private readonly router: Router,
    private readonly dayBookService: DayBookService
  ) {}

  ngOnInit(): void {
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      first()
    ).subscribe((event: any) => {
      const targetUrl = event.url || '';
      if (!targetUrl.includes('day-book')) {
        this.dayBookService.clearSavedDayBookDate();
      }
    });

    const today = new Date();
    this.maxDate = {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate()
    };
    this.selectedMonth = dayjs().format('MMMM YYYY');
    this.initForm();
    this.getBranchList();
    this.loadUpcomingSettlements();
    this.loadAccounts();
    this.getHighlights();
    this.getManualPaymentAccounts();
    this.getAllPaymentAccounts();
  }

  initForm(): void {
    const notZeroValidator = (control: any) => {
      const val = control.value;
      if (val !== null && val !== undefined && val !== '' && Number(val) === 0) {
        return { notZero: true };
      }
      return null;
    };
    this.manualSettlementForm = this.fb.group({
      accountId: [null, Validators.required],
      balanceAccountId: [null, Validators.required],
      amount: [null, [Validators.required, notZeroValidator]],
      settlementDate: [dayjs().format('YYYY-MM-DD'), Validators.required]
    });
    this.updateNgbDate(this.manualSettlementForm.get('settlementDate')?.value);
  }

  getBranchList() {
    this.companyService.getToCompanyList().subscribe((res: any) => {
      let branchList = res.data || [];
      branchList = branchList?.filter((company: any) => company.status === 'Active') || [];
      this.branches = branchList
    });
  }

  getHighlights() {
    this.settlementsService.getHistoryCount({}).subscribe({
      next: (res: any) =>{
        this.cardValues.historyCount = this.cmns.parseNumberOrZero(res?.data)
      }
    })

    this.settlementsService.getSummaryCards({}).subscribe({
      next: (res: any) => {
        let data = res?.data || {}
        this.cardValues.upcomingCount = this.cmns.parseNumberOrZero(data.upcomingCount)
        this.cardValues.settledAmount = this.cmns.parseNumberOrZero(data?.settledThisMonth?.amount)
        this.cardValues.settledCount = this.cmns.parseNumberOrZero(data?.settledThisMonth?.count)
        this.cardValues.nextSheduleDate = data?.nextScheduled?.date || '';
      }
    })
  }

  loadUpcomingSettlements(): void {
    this.loader = true;
    this.errorMessage = '';

    const payload: any = {};
    if (this.filters.accountId) {
      payload.accountId = this.filters.accountId;
    }
    if (this.filters.selectedType) {
      payload.selectedType = this.filters.selectedType;
    }
    if (this.filters.company) {
      payload.company = this.filters.company;
    }

    this.settlementsService.getUpcomingSettlements(payload).subscribe({
      next: (res: any) => {
        const rawData = res?.data || [];
        this.upcomingList = rawData.map((item: any) => {
          item.netPending = this.cmns.parseNumberOrZero(item.netPending);
          return item;
        });
        this.loader = false;
      },
      error: (err: any) => {
        this.loader = false;
        this.errorMessage = err?.error?.error?.message || err?.error?.message || 'Failed to load upcoming settlements';
      }
    });
  }

  loadSettlementsHistory(): void {
    if (this.historyEndOfResult) return;
    this.loader = true;
    this.errorMessage = '';

    const payload: any = {
      page: this.filters.page
    };
    if (this.filters.accountId) {
      payload.accountId = this.filters.accountId;
    }
    if (this.filters.selectedType) {
      payload.settlementType = this.filters.selectedType;
    }
    if (this.filters.company) {
      payload.company = this.filters.company;
    }
    if (this.filters.created_datefrom) {
      payload.created_datefrom = this.filters.created_datefrom;
    }
    if (this.filters.created_dateupto) {
      payload.created_dateupto = this.filters.created_dateupto;
    }

    this.settlementsService.getSettlementsHistory(payload).subscribe({
      next: (res: any) => {
        const rawData = res?.data || [];
        const parsedData = rawData.map((item: any) => {
          item.amount = this.cmns.parseNumberOrZero(item.amount);
          return item;
        });
        this.historyList = [...this.historyList, ...parsedData];
        this.loader = false;

        if (rawData.length === 0) {
          this.historyEndOfResult = true;
        }
      },
      error: (err: any) => {
        this.loader = false;
        this.errorMessage = err?.error?.error?.message || err?.error?.message || 'Failed to load settlements history';
      }
    });
  }

  loadAccounts(): void {
    this.balanceAccountService.getBalanceAccounts({status: 'Active'}).subscribe({
      next: (res: any) => {
        this.balanceAccounts = res?.data || [];
      }
    });
  }

  getManualPaymentAccounts() {
    this.manualPaymentAccountsObj.loader = true;
    const payload: any = {
      page: this.manualPaymentAccountsObj.page,
      settlementType: 'Manual'
    };
    if (this.manualPaymentAccountsObj.searchTerm) {
      payload.accountName = this.manualPaymentAccountsObj.searchTerm;
    }
    this.paymentAccountsService.getCompanyPaymentAccount(payload).subscribe({
      next: (res: any) => {
        const list = res?.data || [];
        const rawList = [...this.manualPaymentAccounts, ...list];
        const uniqueList = [];
        const seenIds = new Set();
        for (const item of rawList) {
          if (item?._id && !seenIds.has(item._id)) {
            seenIds.add(item._id);
            uniqueList.push(item);
          }
        }
        this.manualPaymentAccounts = uniqueList;
        this.manualPaymentAccountsObj.loader = false;
        if (list.length === 0) {
          this.manualPaymentAccountsObj.endofResult = true;
        }
      },
      error: (err: any) => {
        this.manualPaymentAccountsObj.loader = false;
      }
    });
  }

  onManualPaymentAccountInputChange(event: any) {
    this.manualPaymentAccounts = [];
    this.manualPaymentAccountsObj.page = 0;
    this.manualPaymentAccountsObj.searchTerm = event?.term ? event.term : '';
    this.getManualPaymentAccounts();
  }

  onManualPaymentAccountScrollToEnd() {
    if (this.manualPaymentAccountsObj.loader || this.manualPaymentAccountsObj.endofResult) return;
    this.manualPaymentAccountsObj.page++;
    this.getManualPaymentAccounts();
  }

  getAllPaymentAccounts() {
    this.paymentAccountsObj.loader = true;
    const payload: any = {
      page: this.paymentAccountsObj.page
    };
    if (this.paymentAccountsObj.searchTerm) {
      payload.accountName = this.paymentAccountsObj.searchTerm;
    }
    this.paymentAccountsService.getCompanyPaymentAccount(payload).subscribe({
      next: (res: any) => {
        const list = res?.data || [];
        this.paymentAccounts = [...this.paymentAccounts, ...list];
        this.paymentAccountsObj.loader = false;
        if (list.length === 0) {
          this.paymentAccountsObj.endofResult = true;
        }
      },
      error: () => {
        this.paymentAccountsObj.loader = false;
      }
    });
  }

  onFilterPaymentAccountInputChange(event: any) {
    this.paymentAccounts = [];
    this.paymentAccountsObj.page = 0;
    this.paymentAccountsObj.endofResult = false;
    this.paymentAccountsObj.searchTerm = event?.term ? event.term : '';
    this.getAllPaymentAccounts();
  }

  onFilterPaymentAccountScrollToEnd() {
    if (this.paymentAccountsObj.endofResult || this.paymentAccountsObj.loader) return;
    this.paymentAccountsObj.page++;
    this.getAllPaymentAccounts();
  }

  selectedDaysLabel: string = 'All time';

  openCalendar() {
    const modalRef = this.modalService.open(RangeDatePickerComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.initialFromDate = this.filters.created_datefrom || null;
    modalRef.componentInstance.initialToDate = this.filters.created_dateupto || null;

    modalRef.result.then((result) => {
      if (result?.fromDate && result?.toDate) {
        this.filters.created_datefrom = result.fromDate;
        this.filters.created_dateupto = result.toDate;
        this.selectedDaysLabel = '';
        this.onFilterChange();
      }
    }, () => { });
  }

  applyDaysRange(days: any, label: string) {
    if (days === 'all') {
      this.filters.created_datefrom = '';
      this.filters.created_dateupto = '';
      this.selectedDaysLabel = 'All time';
    } else {
      const today = dayjs();
      const start = today.subtract(days - 1, 'day');
      const end = today;
      this.filters.created_datefrom = start.format('YYYY-MM-DD');
      this.filters.created_dateupto = end.format('YYYY-MM-DD');
      this.selectedDaysLabel = label;
    }
    this.onFilterChange();
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    return dayjs(dateStr).format('DD MMM YYYY');
  }

  get selectedDateRangeText(): string {
    const from = this.filters.created_datefrom;
    const to = this.filters.created_dateupto;
    if (!from || !to) return 'All time';
    if (this.selectedDaysLabel) return this.selectedDaysLabel;
    if (from === to) {
      return this.formatDate(from);
    }
    return `${this.formatDate(from)} - ${this.formatDate(to)}`;
  }

  switchTab(tab: 'upcoming' | 'history'): void {
    this.activeTab = tab;
    this.filters.accountId = null;
    this.filters.selectedType = '';
    this.filters.created_datefrom = '';
    this.filters.created_dateupto = '';
    this.filters.company = null;
    this.selectedDaysLabel = 'All time';
    this.onFilterChange();
  }

  onFilterChange(): void {
    this.filters.page = 0;
    this.historyEndOfResult = false;
    if (this.activeTab === 'upcoming') {
      this.upcomingList = [];
      this.loadUpcomingSettlements();
    } else {
      this.historyList = [];
      this.loadSettlementsHistory();
    }
  }

  onScrollHistory(): void {
    if (this.historyEndOfResult || this.loader) return;
    this.filters.page++;
    this.loadSettlementsHistory();
  }

  openRecordManualSettlementModal(content: TemplateRef<any>): void {
    this.modalErrorMessage = '';
    this.modalLoader = false;
    this.initForm();

    this.modalRef = this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'manual-settlement-modal-wrapper'
    });
  }

  quickRecordSettlement(item: any, content: TemplateRef<any>): void {
    this.modalErrorMessage = '';
    this.modalLoader = false;
    this.initForm();

    const sourceAcc = item.accountDetails;
    if (sourceAcc?._id) {
      const exists = this.manualPaymentAccounts.some(acc => acc._id === sourceAcc._id);
      if (!exists) {
        this.manualPaymentAccounts.unshift({
          _id: sourceAcc._id,
          accountName: sourceAcc.accountName,
          paymentType: sourceAcc.paymentType,
          settlementType: sourceAcc.settlementType
        });
      }
    }


    this.manualSettlementForm.patchValue({
      accountId: sourceAcc?._id || null,
      balanceAccountId:  null,
      amount: this.cmns.parseNumberOrZero(item.netPending) || null,
      settlementDate: dayjs().format('YYYY-MM-DD')
    });

    this.updateNgbDate(this.manualSettlementForm.get('settlementDate')?.value);

    this.modalRef = this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      windowClass: 'manual-settlement-modal-wrapper'
    });
  }

  onDateSelect(date: NgbDateStruct): void {
    if (date) {
      const dateStr = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
      this.manualSettlementForm.get('settlementDate')?.setValue(dateStr);
      this.selectedNgbDate = date;
    }
  }

  updateNgbDate(dateStr: string): void {
    if (dateStr?.split('-').length === 3) {
      const parts = dateStr.split('-');
      this.selectedNgbDate = {
        year: Number.parseInt(parts[0], 10),
        month: Number.parseInt(parts[1], 10),
        day: Number.parseInt(parts[2], 10)
      };
    } else {
      const today = new Date();
      this.selectedNgbDate = {
        year: today.getFullYear(),
        month: today.getMonth() + 1,
        day: today.getDate()
      };
    }
  }

  get settlementDateFormatted(): string {
    const val = this.manualSettlementForm.get('settlementDate')?.value;
    return val ? dayjs(val).format('DD MMM YYYY') : 'Select Date';
  }

  saveManualSettlement(): void {
    if (this.manualSettlementForm.invalid) {
      this.manualSettlementForm.markAllAsTouched();
      return;
    }

    this.modalLoader = true;
    this.modalErrorMessage = '';

    const formValues = this.manualSettlementForm.value;
    const payload = {
      ...formValues,
      settlementType: 'Manual'
    };

    this.settlementsService.createSettlement(payload).subscribe({
      next: () => {
        this.modalLoader = false;
        if (this.modalRef) {
          this.modalRef.close();
        }
        this.onFilterChange();
        this.getHighlights();
        this.toasterMessage = "Settlement is created successfully"
      },
      error: (err: any) => {
        this.modalLoader = false;
        this.modalErrorMessage = err?.error?.error?.message || err?.error?.message || 'Failed to save manual settlement';
      }
    });
  }

  closeModal(): void {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  closeToaster() {
    this.toasterMessage = '';
  }

}
